import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import DataService from "../../Service";
import AddToListModal from "./addToListModal";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TOGGLE_GROWING_LIST_POPUP } from "../../Redux/actions";
import { Typography } from "@material-ui/core";

import {
  Select,
  FormControl,
  FormHelperText,
  MenuItem,
  Grid,
} from "@material-ui/core";
import { DatePicker } from "./datepicker_component";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: "100%",
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
    placeholder: {
      paddingLeft: "10px",
      color: "gray",
    },
    inputLabel: {
      // paddingLeft: '14px',
      // marginTop: '-8px',
      color: "#a9a9a9 !important",
    },
    root: {
      // color: '#f44336',
      // '& .Mui-error':{
      //   color: '#a9a9a9 !important'
      // }
    },
  })
);

// export const FormDialog = (props: any) => {
//   const [open, setOpen] = React.useState(props.show);
//   const dispatch = useDispatch();

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     // props.setShowModal(false);
//     // dispatch(TOGGLE_GROWING_LIST_POPUP);
//   };

//   return (
//     <div>
//       <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
//         <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             To subscribe to this website, please enter your email address here. We will send updates
//             occasionally.
//           </DialogContentText>
//           <TextField
//             autoFocus
//             margin="dense"
//             id="name"
//             label="Email Address"
//             type="email"
//             fullWidth
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button  disableElevation  onClick={handleClose} color="primary">
//             Cancel
//           </Button>
//           <Button  disableElevation  onClick={handleClose} color="primary">
//             Subscribe
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

export const SimpleSelect = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    label,
    type,
    selectOptions,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    apiVariable,
    params,
    handleChange,
    index,
    isDynamicField,
    dropDown,
    field_name,
    moduleName,
  } = props.componentObject;

  // const [selectedValue, setSelectedValue] = useState("");
  const [listOptions, setListoptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({});

  useEffect(() => {
    apiVariable &&
      DataService.getData(params ? params : "", apiVariable).then((res) => {
        setListoptions(res.data.attributes.drop_down_values);
      });
  }, [apiVariable, showModal]);

  const handleAddNew = (event: any) => {
    event.preventDefault();
    setPostData({ drop_down: dropDown, field_name: field_name });
    setShowModal(true);
    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
  };

  return (
    <FormControl
      size="small"
      variant={"outlined"}
      style={{ color: "#a9a9a9" }}
      className={clsx(classes.formControl, classes.root)}
      error={helperText ? true : false}
    >
      {(value === undefined ||
        (value && value?.length === 0) ||
        value === "" ||
        value == 0) && (
        <InputLabel
          shrink={false}
          className={classes.inputLabel}
          id="demo-simple-select-outlined-label"
        >
          <Typography variant="h2">{placeholder}</Typography>
        </InputLabel>
      )}
      {/* {((value === undefined) || (value === "") || (value && value.length === 0)) && <InputLabel  className={classes.inputLabel} shrink={false}  id="demo-simple-select-outlined-label">{placeholder}</InputLabel>} */}
      <Select
        name={name}
        // style={{color: ((value === undefined) || (value === "") || (value && value.length === 0)) ? '#a9a9a9' : '' }}
        displayEmpty
        disabled={disabled}
        value={value ? value : []}
        onChange={(e) => {
          e.target.value !== "Add New"
            ? isDynamicField === 0 || isDynamicField
              ? handleChange(e.target.value, index, "", isDynamicField)
              : handleChange(e.target.value, index)
            : handleAddNew(e);
        }}
      >
        <MenuItem disabled className={classes.placeholder}>
          <Typography variant="h2">{placeholder}</Typography>
        </MenuItem>
        {(selectOptions || listOptions).map((option: any, index: any) => {
          return (
            <MenuItem key={option.id} value={option.id}>
              <Typography variant="h2">{option.value}</Typography>
            </MenuItem>
          );
        })}
        {dropDown && field_name && (
          <MenuItem key="Add New" value="Add New">
            <Typography variant="h2">+ Add New</Typography>
          </MenuItem>
        )}
      </Select>
      <span
        style={{ color: "#f44336", fontSize: "0.75rem", marginRight: "14px" }}
      >
        {" "}
        {helperText}
      </span>
      {showModal && (
        <AddToListModal
          setShowModal={setShowModal}
          postData={postData}
          type={moduleName}
        />
      )}
    </FormControl>
  );
};

export default function SelectComponent(props: any) {
  // console.log(props)
  const classes = useStyles();
  const { label, componentType } = props.componentObject;

  return (
    <Grid container className={classes.gridRoot}>
      <Grid xs={12} md={4}>
        {label}
      </Grid>
      {componentType === "select" && (
        <Grid xs={12} md={7}>
          <SimpleSelect componentObject={props.componentObject} />
        </Grid>
      )}
      {componentType === "selectWithDatePicker" && (
        <Grid xs={12} md={4}>
          <SimpleSelect componentObject={props.componentObject} />
        </Grid>
      )}
      {componentType === "selectWithDatePicker" && (
        <Grid xs={12} md={3}>
          <DatePicker componentObject={props.componentObject} />
        </Grid>
      )}
    </Grid>
  );
}
